// Place all the behaviors and hooks related to the matching controller here.
// All this logic will automatically be available in application.js.
$(document).on("turbo:load", () => $("#matter_import_user_id").select2({placeholder: "  関与弁護士", allowClear: false}));
